import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class MapAnalyticsService {
  constructor(private http: HttpClient) {}

  public fetchDashboards(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/mapDashboard/list`
    return this.http.get(url, {})
  }

  public fetchDashboardData(key: string, params: any): Observable<any> {
    const url = `${environment.API_ENDPOINT}/mapDashboard/process/${key}`
    return this.http.post(url, {
      params,
    })
  }
}
